// extracted by mini-css-extract-plugin
export default {"shortText":"PlaygroundTokenUsageWidget-module__shortText__iEGOryp","longText":"PlaygroundTokenUsageWidget-module__longText__vfmxsNd"};